import React from 'react';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import Typography from '@material-ui/core/Typography';

import PersonOutlinedIcon from '@material-ui/icons/PersonOutlined';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import AccountBalanceOutlinedIcon from '@material-ui/icons/AccountBalanceOutlined';
import EditIcon from '@material-ui/icons/EditOutlined';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';

import ContentRow from '../../../../../components/ContentRow/ContentRow';
import ActionButton from '../../../../../components/ActionButton/ActionButton';
import PageHeading from '../../../../../components/PageHeading/PageHeading';

import {
  getString,
  stringToDate,
} from '../../../../../helpers/stringHelpers.js';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

const stringsComponent = 'bankDetails';

class BankDetailsCard extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      classes,
      accountName,
      bankName,
      accountNumber,
      createdDate,
      refreshRequired,
      editAction,
      removeAction,
      createAction,
      primary,
      hasEmail,
      canEdit,
      isInvalid,
    } = this.props;

    console.log('isInvalid', isInvalid);

    const heading = primary
      ? getString(stringsComponent, 'PRIMARY_ACCOUNT_TITLE')
      : getString(stringsComponent, 'SECONDARY_ACCOUNT_TITLE');

    return (
      <div className={classes.root}>
        <Grid container spacing={16}>
          <Grid item xs={12}>
            <div className={classes.heading}>
              <PageHeading heading={heading} isSubheading={true} />
              {hasEmail && canEdit && (
                <div className={classes.buttons}>
                  {refreshRequired ? (
                    <Typography compoment="span" className={classes.updating}>
                      {getString('contactDetails', 'UPDATING_TEXT')}
                    </Typography>
                  ) : !accountName &&
                    !accountNumber &&
                    !bankName &&
                    !createdDate ? (
                    <ActionButton
                      icon={EditIcon}
                      action={createAction}
                      label={getString('profile', 'ADD_BUTTON_LABEL')}
                      labelHidden={false}
                      withBorder={true}
                      withPadding={true}
                    />
                  ) : (
                    <React.Fragment>
                      <ActionButton
                        icon={EditIcon}
                        action={editAction}
                        label={getString('profile', 'EDIT_BUTTON_LABEL')}
                        labelHidden={false}
                        withBorder={true}
                        withPadding={true}
                      />
                      &nbsp;
                      <ActionButton
                        icon={DeleteOutlineIcon}
                        action={removeAction}
                        label={getString('profile', 'REMOVE_BUTTON_LABEL')}
                        withBorder={true}
                      />
                    </React.Fragment>
                  )}
                </div>
              )}
            </div>
            <Hidden lgUp>
              <div>
                <div className={classes.iconFieldWrapper}>
                  <PersonOutlinedIcon className={`${classes.icon} ItemIcon`} />
                  <div>
                    <Typography className={classes.label}>
                      {getString(stringsComponent, 'ACCOUNT_NAME_LABEL')}
                    </Typography>
                    <ContentRow customClass={classes.contentRow}>
                      <Typography className={classes.value}>
                        {accountName}
                      </Typography>
                    </ContentRow>
                  </div>
                </div>
                <div className={classes.iconFieldWrapper}>
                  <AssignmentOutlinedIcon
                    className={`${classes.icon} ItemIcon`}
                  />
                  <div>
                    <Typography className={classes.label}>
                      {getString(stringsComponent, 'ACCOUNT_NUMBER_LABEL')}
                    </Typography>
                    <ContentRow customClass={classes.contentRow}>
                      <Typography className={classes.value}>
                        {accountNumber}
                      </Typography>
                    </ContentRow>
                    {isInvalid && (
                      <Typography className={classes.invalidAccount}>
                        {getString(stringsComponent, 'INVALID_ACCOUNT')}
                      </Typography>
                    )}
                  </div>
                </div>
                <div className={classes.iconFieldWrapper}>
                  <AccountBalanceOutlinedIcon
                    className={`${classes.icon} ItemIcon`}
                  />
                  <div>
                    <Typography className={classes.label}>
                      {getString(stringsComponent, 'BANK_NAME_LABEL')}
                    </Typography>
                    <ContentRow customClass={classes.contentRow}>
                      <Typography className={classes.value}>
                        {bankName}
                      </Typography>
                    </ContentRow>
                  </div>
                </div>
                {createdDate && (
                  <Typography className={classes.bottomText}>
                    {getString(stringsComponent, 'CREATED_DATE_LABEL')}
                    {' | '}
                    {stringToDate(createdDate)}
                  </Typography>
                )}
              </div>
            </Hidden>
            <Hidden mdDown>
              <div className={classes.line}>
                <div className={classes.iconFieldWrapper}>
                  <PersonOutlinedIcon className={`${classes.icon} ItemIcon`} />
                  <div>
                    <Typography className={classes.label}>
                      {getString(stringsComponent, 'ACCOUNT_NAME_LABEL')}
                    </Typography>
                    <ContentRow customClass={classes.contentRow}>
                      <Typography className={classes.value}>
                        {accountName}
                      </Typography>
                    </ContentRow>
                  </div>
                </div>
                <div className={classes.iconFieldWrapper}>
                  <AssignmentOutlinedIcon
                    className={`${classes.icon} ItemIcon`}
                  />
                  <div>
                    <Typography className={classes.label}>
                      {getString(stringsComponent, 'ACCOUNT_NUMBER_LABEL')}
                    </Typography>
                    <ContentRow customClass={classes.contentRow}>
                      <Typography className={classes.value}>
                        {accountNumber}
                      </Typography>
                    </ContentRow>
                    {isInvalid && (
                      <Typography className={classes.invalidAccount}>
                        {getString(stringsComponent, 'INVALID_ACCOUNT')}
                      </Typography>
                    )}
                  </div>
                </div>
              </div>
              <div className={classes.line}>
                <div className={classes.iconFieldWrapper}>
                  <AccountBalanceOutlinedIcon
                    className={`${classes.icon} ItemIcon`}
                  />
                  <div>
                    <Typography className={classes.label}>
                      {getString(stringsComponent, 'BANK_NAME_LABEL')}
                    </Typography>
                    <ContentRow customClass={classes.contentRow}>
                      <Typography className={classes.value}>
                        {bankName}
                      </Typography>
                    </ContentRow>
                  </div>
                </div>
              </div>
              <div className={classes.line}>
                <div className={classes.iconFieldWrapper}>
                  {createdDate ? (
                    <Typography className={classes.bottomText}>
                      {getString(stringsComponent, 'CREATED_DATE_LABEL')}
                      {' | '}
                      {stringToDate(createdDate)}
                    </Typography>
                  ) : null}
                </div>
              </div>
            </Hidden>
          </Grid>
        </Grid>
      </div>
    );
  }
}

BankDetailsCard.propTypes = {
  classes: PropTypes.object.isRequired,
  canEdit: PropTypes.bool.isRequired,
};

BankDetailsCard.defaultProps = {};

export default withStyles(styles, { withTheme: true })(BankDetailsCard);
